import React from "react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="container-xl py-14 md:py-20 max-w-3xl prose prose-neutral">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">Legal</div>
      <h1 className="editorial-heading text-4xl md:text-5xl mb-2">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="mt-10 space-y-8 text-sm md:text-base leading-relaxed text-foreground/85">
        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">1. Titolare del trattamento</h2>
          <p>Il Titolare del trattamento dei dati personali è <strong>Amazonico 3000 S.r.l.</strong>, con sede legale in Milano (Italia). Email di contatto per questioni privacy: <a href="mailto:privacy@amazonico3000.com" className="text-[hsl(var(--primary))] underline">privacy@amazonico3000.com</a>.</p>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">2. Dati raccolti</h2>
          <ul className="list-disc pl-6 space-y-1.5">
            <li><strong>Dati di registrazione</strong>: nome, email, password (hash), paese, lingua, ruolo (b2c/b2b/admin).</li>
            <li><strong>Dati B2B</strong>: ragione sociale, P.IVA, sede operativa (solo per utenti registrati come buyer).</li>
            <li><strong>Dati di navigazione</strong>: IP, browser, pagine visitate, prodotti visualizzati, carrello (sessione).</li>
            <li><strong>Dati di ordine</strong>: indirizzo di spedizione, fatturazione, metodo di pagamento (gestito da Stripe).</li>
            <li><strong>Consensi</strong>: preferenze cookie, iscrizione newsletter, adesione Club.</li>
          </ul>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">3. Finalità e base giuridica</h2>
          <p>I dati sono trattati per:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li><strong>Esecuzione del contratto</strong> (art. 6.1.b GDPR): gestione ordini, spedizioni, supporto.</li>
            <li><strong>Obblighi legali</strong> (art. 6.1.c): fatturazione, adempimenti fiscali.</li>
            <li><strong>Interesse legittimo</strong> (art. 6.1.f): prevenzione frodi, miglioramento servizio.</li>
            <li><strong>Consenso</strong> (art. 6.1.a): newsletter, marketing personalizzato, cookie non essenziali.</li>
          </ul>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">4. Conservazione</h2>
          <p>I dati vengono conservati per il tempo strettamente necessario:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Dati account: fino alla cancellazione dell'account + 30 giorni di backup.</li>
            <li>Dati fiscali/ordini: 10 anni (obbligo di legge).</li>
            <li>Iscrizione newsletter: fino alla disiscrizione.</li>
            <li>Log consensi: 24 mesi.</li>
          </ul>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">5. Destinatari</h2>
          <p>I tuoi dati possono essere condivisi con:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li><strong>Stripe Payments Europe Ltd.</strong> — processore dei pagamenti.</li>
            <li><strong>Corrieri di spedizione</strong> (GLS, BRT, DHL) — solo dati di consegna.</li>
            <li><strong>Fornitori cloud</strong> (database, email transazionali) — contratti DPA conformi GDPR.</li>
            <li><strong>Autorità competenti</strong> solo se richiesto per legge.</li>
          </ul>
          <p className="mt-3">Non cediamo né vendiamo i tuoi dati a terze parti per finalità di marketing.</p>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">6. Diritti dell'interessato</h2>
          <p>Ai sensi degli artt. 15-22 GDPR hai il diritto di:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Accedere ai tuoi dati e ottenerne copia</li>
            <li>Rettificare dati inesatti</li>
            <li>Cancellare i dati (diritto all'oblio)</li>
            <li>Limitare il trattamento</li>
            <li>Opporti al trattamento</li>
            <li>Ricevere i dati in formato portabile (JSON/CSV)</li>
            <li>Revocare i consensi in qualsiasi momento</li>
            <li>Presentare reclamo al Garante Privacy italiano</li>
          </ul>
          <p className="mt-3">Per esercitare questi diritti scrivi a <a href="mailto:privacy@amazonico3000.com" className="text-[hsl(var(--primary))] underline">privacy@amazonico3000.com</a>. Risponderemo entro 30 giorni.</p>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">7. Trasferimenti extra-UE</h2>
          <p>Eventuali trasferimenti fuori UE avvengono solo verso paesi adeguati o con Clausole Contrattuali Standard (SCC) approvate dalla Commissione UE.</p>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">8. Sicurezza</h2>
          <p>Adottiamo misure tecniche e organizzative adeguate: cifratura in transit (HTTPS/TLS 1.3) e at-rest, password hashate con bcrypt, controllo accessi role-based, logging, backup giornalieri.</p>
        </section>
      </div>
    </div>
  );
}
